module.exports = __webpack_public_path__ + "img/2__529-81-low.d3649b2a.jpg";